import { defaultStylingSchema } from '../schema';

export const ButtonStylingSchema = ({ schema, formData, intl }) => {
  defaultStylingSchema({ schema, formData, intl });

  return schema;
};
